import { buildSubscriptionPanel } from "../subscriptionPanel";

/**
 * Paywall modal markup. Uses the unified subscription panel component
 * (same as the avatar dropdown, gates, and profile). Per-tier price /
 * save / bill text is rendered as placeholder spans filled at runtime
 * by the single subscription chooser controller.
 */
export const paywallMarkup = String.raw`<!-- Paywall Modal -->
<div class="modal-overlay paywall-modal" id="paywallModal">
  <div class="modal">
    <div class="modal-header">
      <div class="pw-header">
        <h3 class="modal-title">Choose your plan</h3>
        <p id="paywallIntentNote" class="modal-description" style="display:none"></p>
        <p id="paywallTargetPlan" hidden>Pro</p>
      </div>
      <button type="button" class="modal-close" data-proto-click="closePaywall()" aria-label="Close membership plans">
        <svg aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
      </button>
    </div>
    <div class="modal-body">
			${buildSubscriptionPanel({ prefix: 'pw', mode: 'checkout' })}
    </div>
  </div>
</div>

`;
